import axiosInstance from "@/axios/axiosInstance";
import {
  GetNotificationsResponse,
  MarkAllAsReadResponse,
  MarkAsReadResponse,
  GetNotificationsRequest,
  GetNotificationPreferenceResponse,
  UpdateNotificationPreferenceRequest,
  UpdateNotificationPreferenceResponse,
} from "@/interface/notification.types";

/**
 * Service for notification related API calls
 */
export const getNotifications = async (
  request?: Partial<GetNotificationsRequest>
): Promise<GetNotificationsResponse> => {
  try {
    const payload: GetNotificationsRequest = {
      pageNumber: request?.pageNumber ?? 1,
      pageSize: request?.pageSize ?? 10,
      query: request?.query ?? "",
      filters: request?.filters ?? "",
      sorts: request?.sorts ?? "",
    };

    const response = await axiosInstance.post<GetNotificationsResponse>(
      "/Notification/Notification",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch notifications:", error);
    throw error;
  }
};

/**
 * Mark all notifications as read
 */
export const markAllAsRead = async (): Promise<MarkAllAsReadResponse> => {
  try {
    const response = await axiosInstance.post<MarkAllAsReadResponse>(
      "/Notification/MarkAllAsRead"
    );
    return response.data;
  } catch (error) {
    console.error("Failed to mark all notifications as read:", error);
    throw error;
  }
};

/**
 * Mark a single notification as read
 */
export const markAsRead = async (
  notificationId: string
): Promise<MarkAsReadResponse> => {
  try {
    const response = await axiosInstance.post<MarkAsReadResponse>(
      `/Notification/MarkAsRead?notificationId=${encodeURIComponent(notificationId)}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to mark notification as read:", error);
    throw error;
  }
};

/**
 * Get notification preferences
 */
export const getNotificationPreference =
  async (): Promise<GetNotificationPreferenceResponse> => {
    try {
      const response = await axiosInstance.get<GetNotificationPreferenceResponse>(
        "/Notification/GetNotificationPreference"
      );
      return response.data;
    } catch (error) {
      console.error("Failed to fetch notification preferences:", error);
      throw error;
    }
  };

/**
 * Update notification preferences
 */
export const updateNotificationPreference = async (
  payload: UpdateNotificationPreferenceRequest
): Promise<UpdateNotificationPreferenceResponse> => {
  try {
    const response = await axiosInstance.post<UpdateNotificationPreferenceResponse>(
      "/Notification/UpdateNotificationPreference",
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getMessageNotifications = async (
  request?: Partial<GetNotificationsRequest>
): Promise<GetNotificationsResponse> => {
  try {
    const payload: GetNotificationsRequest = {
      pageNumber: request?.pageNumber ?? 1,
      pageSize: request?.pageSize ?? 10,
      query: request?.query ?? "",
      filters: request?.filters ?? "",
      sorts: request?.sorts ?? "",
    };

    const response = await axiosInstance.post<GetNotificationsResponse>(
      "/Notification/MessageNotification",
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

